import React, { FC } from 'react';
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@material-ui/core';
import { LegacyAgency } from '../../interfaces/api/Agency';

interface Props {
  className?: any;
  agencies: Omit<LegacyAgency, 'siret'>[];
  multiple?: boolean;
}

interface MultipleSelectProps extends Props {
  agencyId: number[];
  onChange: (agencyId: number[]) => void;
}

interface SingleSelectProps extends Props {
  agencyId: number;
  onChange: (agencyId: number) => void;
}

const LegacyAgencySelect: FC<SingleSelectProps | MultipleSelectProps> = ({
  className,
  agencies,
  agencyId,
  multiple,
  onChange,
}) => {
  const handleChange = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    const id = event.target.value;
    onChange(id);
  };

  const renderValue = (selectedIds) => {
    if (Array.isArray(selectedIds)) {
      const selectedAgenciesNames = selectedIds.map(
        (id: LegacyAgency['id']) => agencies.find((agency) => agency.id === id)?.name || ''
      );
      return selectedAgenciesNames.join(', ');
    }

    return agencies.find((agency) => agency.id === selectedIds)?.name || '';
  };

  const isMultiple = (agencyId: number | number[]): agencyId is number[] => !!multiple;

  return (
    <FormControl size='small' variant='outlined' className={className}>
      <InputLabel>Agence</InputLabel>
      <Select multiple={multiple} renderValue={renderValue} onChange={handleChange} label='Agence' value={agencyId}>
        {agencies.map((agency, key) => (
          <MenuItem key={key} value={agency.id}>
            {isMultiple(agencyId) && <Checkbox checked={agencyId.indexOf(agency.id) > -1} />}
            <ListItemText primary={agency.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LegacyAgencySelect;
